import { Injectable } from '@angular/core';
// import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
// import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';

@Injectable()
export class TemplateManagerProvider {
  arrTemplates: any = [];
  selTemplate: any = {};
  constructor() {
  }

  getTemplates(cbck): any {
    /*
    if( !this.arrTemplates || !this.arrTemplates.length) {
      this.driveService.getTemplates((data)=>{
        this.arrTemplates = data;
        cbck(data);
      });
    } else {
      cbck(this.arrTemplates);
    }
*/
  }

  pushTemplates(arrTemplates) {
    this.arrTemplates = arrTemplates
  }

  pullTemplates() {
    return this.arrTemplates;
  }

  fetchTemplateFieldProperties(templateConfig): any {
    if (templateConfig.ScreenTypeID) {
      if (this.arrTemplates[templateConfig.ScreenTypeID].fieldProperties) {
        return this.arrTemplates[templateConfig.ScreenTypeID].fieldProperties;
      }
    }
  }

  selectTemplate(template): any {

    // this.selTemplate.listViewProps = pluginData.colProps;
  }

  getTemplateListViewProps(template) {

  }

}



// WEBPACK FOOTER //
// ./src/providers/template-manager/template-manager.ts